// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1lwCl","nav":"header-module--nav--1c_kz","menu":"header-module--menu--heg-h","menuItemRight":"header-module--menu-item-right--3QpKq"};